import { render, staticRenderFns } from "./zgzpt.vue?vue&type=template&id=a7024c68&scoped=true&"
import script from "./zgzpt.vue?vue&type=script&lang=js&"
export * from "./zgzpt.vue?vue&type=script&lang=js&"
import style0 from "./zgzpt.vue?vue&type=style&index=0&id=a7024c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7024c68",
  null
  
)

export default component.exports